// 正式
module.exports = {
  title: '共创家—社区后台管理',
  baseUrl: 'http://cbo.gongchuangjia.com/', // 正式项目地址
  baseApi: 'https://applet.gongchuangjia.com/cbo', // 正式api请求地址
  APPID: 'wx489c93ebee8842f2',
  APPSECRET: '',
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
}
